<!-- @format -->

<public-info-tag>
  <div class="container_breadcrumb">
    <ul class="breadcrumb">
      <li class="breadcrumb-item">
        <h1 class="heading-01 heading_skillsheet">公開情報・スキルシート</h1>
      </li>
    </ul>
  </div>
  <!--/.container_breadcrumb-->

  <div class="contents">
    <section class="contents_area">
      <div class="box_w20">
        <a
          class="button button-tertiary margin-spacing-2_bottom"
          href="/menu/public-info/preview"
        >
          プレビューを確認
        </a>
      </div>

      <div class="tab-menu_skillsheet">
        <ul class="tab-menu_skillsheet-list">
          <li
            each="{ tab in Tabs }"
            class="tab-menu_skillsheet-list-item { state.tabName == tab.name ? 'is-active' :'' }"
          >
            <a class="js-tab" onclick="{ e => update({ tabName:tab.name })}">
              <span class="icon_skillsheet"></span>
              { tab.label }
            </a>
          </li>
        </ul>
      </div>
      <!--/.tab-menu-->

      <div
        each="{ tab in Tabs }"
        class="tab_contents { tab.name==state.tabName ? 'active' : '' }"
      >
        <div class="contents_block skillsheet" is="{ tab.name }"></div>
        <!--/.contents_block-->
      </div>
    </section>
    <!--/.contents_area-->
  </div>
  <!--/.contents-->
  <script>
    import publicInfo from "@tags/parts/public-info/public-info.riot";
    import skillsheet from "@tags/parts/public-info/skillsheet.riot";
    import workHistory from "@tags/parts/public-info/work-history.riot";
    import license from "@tags/parts/public-info/license.riot";
    import works from "@tags/parts/public-info/works.riot";

    export default {
      components: {
        "public-info": publicInfo,
        skillsheet: skillsheet,
        "work-history": workHistory,
        license: license,
        works: works,
      },
      state: {
        tabName: "public-info",
      },
      Tabs: [
        { name: "public-info", label: "公開情報" },
        { name: "skillsheet", label: "スキルシート" },
        { name: "work-history", label: "職歴" },
        { name: "license", label: "資格" },
        { name: "works", label: "制作実績" },
      ],
    };
  </script>
</public-info-tag>
